(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#cookie-consent"]');
    if (!link) return;
    e.preventDefault();

    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openConsentDialog === 'function') {
      window.Shopify.customerPrivacy.openConsentDialog();
      return;
    }
    if (typeof window.CookieYes !== 'undefined' && typeof window.CookieYes.loadBanner === 'function') {
      window.CookieYes.loadBanner();
      return;
    }
    if (typeof window.Cookiebot !== 'undefined') {
      window.Cookiebot.show();
      return;
    }
  });
})();
